<div fxLayout="row" fxLayout.xs="column" fxLayout.sm="column" fxLayout.md="column" fxLayoutGap="25px" fxLayoutGap.xs="0" fxLayoutGap.sm="0" fxLayoutGap.md="0">
    <div fxFlex="33%" fxFlex.xs="100%" fxFlex.sm="100%" fxFlex.lg="33%" fxFlex.md="100%" class="col">

        <app-welcome-dashboard></app-welcome-dashboard>

        <app-analytics-status></app-analytics-status>

    </div>
    <div fxFlex="67%" fxFlex.xs="100%" fxFlex.sm="100%" fxFlex.lg="67%" fxFlex.md="100%" class="col">

        <app-analytics-stats></app-analytics-stats>

        <app-analytics-audience-overview></app-analytics-audience-overview>

    </div>
</div>

<div fxLayout="row" fxLayout.xs="column" fxLayout.sm="column" fxLayout.md="column" fxLayoutGap="25px" fxLayoutGap.xs="0" fxLayoutGap.sm="0" fxLayoutGap.md="0">

    <div fxFlex="66.666666%" fxFlex.xs="100%" fxFlex.sm="100%" fxFlex.md="100%" class="col">
        <div fxLayout="row" fxLayout.xs="column" fxLayout.sm="column" fxLayoutGap="25px" fxLayoutGap.xs="0" fxLayoutGap.sm="0">
            <div fxFlex="66.666666%" fxFlex.xs="100%" fxFlex.sm="100%" class="col">

                <app-sales-analytics></app-sales-analytics>

                <app-revenue-report></app-revenue-report>

            </div>
            <div fxFlex="33.333333%" fxFlex.xs="100%" fxFlex.sm="100%" class="col">

                <app-analytics-total-revenue></app-analytics-total-revenue>

                <app-analytics-activity></app-analytics-activity>

            </div>
        </div>

        <app-browser-used-traffic-reports></app-browser-used-traffic-reports>
    </div>

    <div fxFlex="33.333333%" fxFlex.xs="100%" fxFlex.sm="100%" fxFlex.md="100%" class="col">

        <app-sessions-by-countries></app-sessions-by-countries>

        <app-total-transactions></app-total-transactions>

        <app-terminals></app-terminals>

    </div>

</div>

<div fxLayout="row" fxLayout.xs="column" fxLayout.sm="column" fxLayout.md="column" fxLayoutGap="25px" fxLayoutGap.xs="0" fxLayoutGap.sm="0" fxLayoutGap.md="0">
    <div fxFlex="20%" fxFlex.xs="100%" fxFlex.sm="100%" fxFlex.md="100%" class="col">
        <app-new-vs-returing></app-new-vs-returing>
    </div>
    <div fxFlex="20%" fxFlex.xs="100%" fxFlex.sm="100%" fxFlex.md="100%" class="col">
        <app-analytics-gender></app-analytics-gender>
    </div>
    <div fxFlex="20%" fxFlex.xs="100%" fxFlex.sm="100%" fxFlex.md="100%" class="col">
        <app-visitors-age></app-visitors-age>
    </div>
    <div fxFlex="20%" fxFlex.xs="100%" fxFlex.sm="100%" fxFlex.md="100%" class="col">
        <app-analytics-language></app-analytics-language>
    </div>
    <div fxFlex="20%" fxFlex.xs="100%" fxFlex.sm="100%" fxFlex.md="100%" class="col">
        <app-sessions-device></app-sessions-device>
    </div>
</div>